/**
 * Замок на сессию секретного чата (изменение v1.13).
 *
 * Состояние рэтчета меняется и при отправке (любая вкладка), и при приёме
 * (вкладка-лидер); два параллельных изменения одной сессии разошлись бы с
 * собеседником навсегда. Web Locks действуют между вкладками; там, где их нет
 * (старый WebKit, тесты), остаётся очередь внутри вкладки.
 */
const local = new Map<string, Promise<unknown>>()

export async function withSecretLock<T>(conversationId: string, fn: () => Promise<T>): Promise<T> {
  const name = `dvizh-secret:${conversationId}`
  const locks = (globalThis.navigator as Navigator | undefined)?.locks
  if (locks) return locks.request(name, () => fn())

  const previous = local.get(name) ?? Promise.resolve()
  const run = previous.catch(() => undefined).then(fn)
  local.set(name, run)
  try {
    return await run
  } finally {
    if (local.get(name) === run) local.delete(name)
  }
}
